import { useSelector } from 'react-redux';
import useBackendStatus from '../hooks/useBackendStatus';

const Navbar = () => {
  const user = useSelector((state) => state.auth.user);
  const backendStatus = useBackendStatus(); // defaults to /api/health

  return (
    <div className="flex justify-between items-center px-6 py-3 bg-white border-b shadow">
      <div className="text-lg font-semibold text-gray-800">Welcome, {user?.fullname}</div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">{user?.userType?.usertype}</span>
        <span
          className={`w-3 h-3 rounded-full ${
            backendStatus === null
              ? 'bg-gray-400'
              : backendStatus
              ? 'bg-green-500'
              : 'bg-red-500'
          }`}
          title={
            backendStatus === null
              ? 'Checking...'
              : backendStatus
              ? 'Connected to backend'
              : 'Backend connection failed'
          }
        ></span>
      </div>
    </div>
  );
};

export default Navbar;
